<!-- This component is based on https://ob1.orange.fr/#example/progress-indicators.html -->

<template>
  <svg
    class="ob1-spinner-undetermined"
    viewBox="0 0 50 50"
    :style="style">
    <circle
      class="ob1-spinner-undetermined-circle"
      cx="25"
      cy="25"
      r="20" />
  </svg>
</template>

<script>
export default {
  name: 'WptvSpinner',
  props: {
    size: {
      type: Number,
      default: 20
    }
  },
  computed: {
    style () {
      return `width: ${this.size}px; height: ${this.size}px;`
    }
  }
}
</script>
